import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const paypalApi = createApi({
  reducerPath: reducerPaths.paypalApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createPaypalOrder: builder.mutation({
      query: ({ payload }) => ({
        url: `/paypal/create-order`,
        method: "POST",
        body: payload
      }),
    })
  }),
});

export const {
  useCreatePaypalOrderMutation,
} = paypalApi;